module.exports = __webpack_public_path__ + "media/images/lb/119-574ff5823f72b0b02531b51b94ea19c9.svg";